import React from "react";
import PropTypes from "prop-types";
import omit from "lodash/omit";
import classNames from "classnames";

import CustomIcon from "./CustomIcon";

class CustomButton extends React.PureComponent {
    static propTypes = {
        text: PropTypes.string.isRequired,
        className: PropTypes.string,
        type: PropTypes.string,
        disabled: PropTypes.bool,
        iconType: PropTypes.string,
        iconPosition: PropTypes.string,
        onClick: PropTypes.func.isRequired
    }

    static defaultProps = {
        type: "button",
        iconPosition: "right",
        disabled: false
    }

    renderIcon() {
        if (this.props.iconName) {
            return (<CustomIcon {...this.props} />);
        }
        return null;
    }

    render() {
        let buttonClasses = {
            "custom-button": true
        };

        if (this.props.className) {
            buttonClasses[this.props.className] = true;
        }

        let buttonProps = omit(this.props, ["text", "iconName", "iconPosition"]);

        let iconRight = (this.props.iconPosition == "right");

        return (
            <button {...buttonProps} className={classNames(buttonClasses)}>
                {!iconRight && this.renderIcon()}
                {this.props.text}
                {iconRight && this.renderIcon()}
            </button>
        );
    }
}

export default CustomButton;
